export type Question = {
  text: string;
  value: string;
};

export enum RiskCategory {
  defensive = 'defensive',
  conservative = 'conservative',
  balanced = 'balanced',
  growth = 'growth',
  aggressive = 'aggressive',
  none = 'none',
}

export const riskQuestions: Question[] = [
  {
    text: '1 year or less',
    value: '1yr',
  },
  {
    text: '2-3 years',
    value: '2-3yr',
  },
  {
    text: '4-6 years',
    value: '4-6yr',
  },
  {
    text: '7-9 years',
    value: '7-9yr',
  },
  {
    text: '10+ years',
    value: '10+yr',
  },
];

export const investingQuestions: Question[] = [
  {
    text: 'I know nothing',
    value: 'none',
  },
  {
    text: 'I know a little',
    value: 'low',
  },
  {
    text: "I'm pretty confident",
    value: 'medium',
  },
  {
    text: "I'm an experienced investor",
    value: 'high',
  },
];

export const concernQuestions: Question[] = [
  {
    text: "I can't afford any losses right now",
    value: 'losing',
  },
  {
    text: 'I want growth but nothing too scary',
    value: 'losingAndGaining',
  },
  {
    text: 'I want strong growth, and I can handle the ups and downs',
    value: 'gaining',
  },
];

export const valueDropQuestions: Question[] = [
  {
    text: "I'd panic and switch",
    value: 'change',
  },
  {
    text: "I'd stay the course",
    value: 'stay',
  },
];
